module.exports = __webpack_public_path__ + "static/media/portrait.d2e607a2.png";